import { createSlice } from '@reduxjs/toolkit';

const missionSliceState =
{
    overviewTitle: "Journey Overview",
    referenceMaterialTitle: "Reference Material",
};

const missionSlice = createSlice({
    name: 'mission',
    initialState: missionSliceState,
    reducers: {
        setOverviewTitle(state, action) {
            state.overviewTitle = action.payload;
        },
        setReferenceMaterialTitle(state, action) {
            state.referenceMaterialTitle = action.payload;
        },
    },
});

export default missionSlice;